import styled from 'styled-components'

import { spaces } from '@/config/global-parameters'
import { paddedNumberFormatter } from '@/helpers/formatters'

export interface IParty {
  name?: string
  shortName: string
  size: number
  opaque?: boolean
}

const { format } = paddedNumberFormatter

const Parties = ({ opaque, parties }: { parties: IParty[]; opaque?: boolean }) => (
  <Wrapper
    opaque={opaque}
    partiesCount={parties.length}
  >
    {parties.map((party) => (
      <Party key={party.shortName}>
        <b>{format(party.size)}</b>
        <span>{party.shortName}</span>
      </Party>
    ))}
  </Wrapper>
)

const Party = styled.div`
  font-weight: 400;
  white-space: nowrap;
  display: flex;
  gap: 2px;
`

const Wrapper = styled.div<{ partiesCount: number; opaque?: boolean }>`
  color: black;
  display: grid;
  height: min-content;
  gap: 0 ${spaces.s};
  padding-top: ${spaces.s};
  font-size: 12px;
  opacity: ${({ opaque }) => opaque && '15%'};
  grid: 1fr / 1fr 1fr;
  @media (max-width: calc(${spaces.tabletBreakpoint} + 100px)) {
    grid: 1fr / repeat(1, 1fr);
  }
  @media (max-width: ${spaces.mobileBreakpoint}) {
    font-size: 10px;
  }
`

export default Parties
